import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Chip from "@material-ui/core/Chip";
import Link from "@material-ui/core/Link";

import UserAvatarSmall from "./UserAvatarSmall";
import { COLOR_TRAVALOUR } from "../../config";
import { userUrl } from "../../utils/url";

export default function UserChip({ user }) {
  return (
    <Fragment>
      {!!user ? (
        <Chip
          variant="outlined"
          style={{
            color: "#fff",
            // marginRight: "5px",
            // marginBottom: "5px",
            backgroundColor: `${user.type === 2 || user.type === 3 ? COLOR_TRAVALOUR : "#3B3B3B"
              }`,
            paddingLeft: "4px",
          }}
          avatar={
            <UserAvatarSmall
              mediaId={user.image}
              letter={user.name.substring(0, 1).toUpperCase()}
            />
          }
          label={
            user.type === 2 || user.type === 3 ? (
              <Fragment>
                <Link
                  underline="none"
                  component={RouterLink}
                  style={{ color: "#fff" }}
                  to={`/travalour/${user.id}`}
                >
                  {user.name}
                </Link>
                {!!user.username &&
                  <>
                    {" / "}
                    <Link
                      href={userUrl(user.username, true)}
                      underline="none"
                      target="_blank"
                      style={{ color: "#fff" }}
                    >
                      {`@${user.username}`}
                    </Link>
                  </>}
              </Fragment>
            ) : (
              user.name
            )
          }
        />
      ) : null}
    </Fragment>
  );
}
